import * as React from 'react';
import BOM from "@system/config/bom";
import useReduxState from "../../../hooks/useReduxState";
import store from "../../../storeWire";
import { system_notification } from "../../../store/slice/system";
import { useBOMStore } from "../../../hooks/bom";
import { useBOMProjectStore } from "../../../hooks/bom_project";
import System from "../../../helper/system";
import { Drag } from "../../../component/DragAndDrop/Drag";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { isObject } from "underscore";
import { useEffect } from "react";
import AxiosSingletonLoader from 'src/component/AxiosSingletonLoader';
import AxiosIndicatorRunTimeLoader from 'src/component/AxiosIndicatorRunTimeLoader';
import { SET_DOWNLOAD_LOADER } from 'src/store/slice/model/BOMProject';
import Helper from 'src/support/Helper';
import liveAuth from 'src/helper/liveAuth';
import Constants from "src/support/Constants";
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import { Tooltip } from 'src/component/Tooltip';

const BomListUl = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { listOfBOM, project_id } = props;
    const [{ }, { }, { copy_bom_by_bom_id }] = useBOMStore();
    const [{ }, { fetch_bom_project_detail_with_bom }, { }] = useBOMProjectStore();
    const [find_bom_input_bom_listing] = useReduxState({}, 'find_bom_input_bom_listing');
    const avUserInfo = liveAuth.getAvUserInfo()
    const { sourceOfBOM } = Constants;
    const [_check_p] = useCheckAuthPermissions();

    const getDisplayClass = (singleBOM) => {
        if (!find_bom_input_bom_listing || find_bom_input_bom_listing === '') {
            return 'table-row'
        }
        if (singleBOM.bomName.toLowerCase().includes(find_bom_input_bom_listing.toLowerCase()) === false) {
            return 'none'
        }
        return 'table-row'
    };

    useEffect(() => {
        if (find_bom_input_bom_listing && props.liveTotalCountCallBack !== undefined) {
            let c = Object.entries(listOfBOM).length;
            if (isObject(listOfBOM) && Object.entries(listOfBOM).length > 0 && find_bom_input_bom_listing) {
                Object.keys(listOfBOM).map((v, i) => {
                    if (listOfBOM[v].bomName.toLowerCase().includes(find_bom_input_bom_listing.toLowerCase()) === false) {
                        c--
                    }
                });
            }
            props.liveTotalCountCallBack(c);
        }
    }, [listOfBOM, find_bom_input_bom_listing])

    function bomOpen(){
        localStorage.setItem("adobeEventType","bomOpened");
    }

    return (
        <>
            <ul style={{
                visibility: __check(['BOM_PROJECT_API_CALL']).status > 0 ? 'visible' : 'hidden'
            }}>
                <li>
                    <div className="table-responsive">
                        {/* <table className="table font-12"> */}
                        {__check(['BOM_PROJECT_API_CALL'], {}).render}
                        {/* </table> */}
                    </div>
                </li>
            </ul>
            <ul style={{
                visibility: !__check(['BOM_PROJECT_API_CALL']).status > 0 ? 'visible' : 'hidden'
            }}>
                <li>
                    <div className="table-responsive">
                        <table className="table font-12 bg-grey2">
                            {Object.keys(listOfBOM).map((v, i) => (
                                <Drag key={i} data={listOfBOM[v]} dragFromProject={project_id ? true : false} className="draggable-row" style={{
                                    display: getDisplayClass(listOfBOM[v])
                                }}>
                                    <td>
                                        <a
                                            href={BOM.getBomDetailByIdRouteURL(listOfBOM[v].bomId, {
                                                lifeCycle: listOfBOM[v].bomHealthRisk
                                            })}
                                            className="text-blue2 mb-1 d-block font-bold" onClick={bomOpen}>{listOfBOM[v].bomName}</a>
                                        <p>Last updated: {Helper.dateFormatFromString(listOfBOM[v].updatedDate, true, true)}</p>
                                    </td>
                                    <td>
                                        <div className="text-nowrap d-flex align-items-center">
                                                                                   
                                            {(!Helper.validateDomain(avUserInfo?.email) && (!listOfBOM[v]?.isExternalBom || (listOfBOM[v]?.isExternalBom && !_check_p('DOWNLOAD_BOM').status)))  && (
                                            <AxiosSingletonLoader slugKey={['BOM_OPERATION_API_CALL', 'BOM_PROJECT_API_CALL']}>
                                                <i className="copy-icon font-14 me-2 "></i>
                                                <a href={void (0)}
                                                    onClick={async () => {
                                                        let res = await copy_bom_by_bom_id({ bomId: listOfBOM[v].bomId, source: sourceOfBOM.BOMLIST  });
                                                        await fetch_bom_project_detail_with_bom()
                                                    }}
                                                >Create Copy</a>
                                            </AxiosSingletonLoader>
                                            )}
                                            </div>
                                    </td>
                                    <td>
                                   {(!Helper.validateDomain(avUserInfo?.email) && (!listOfBOM[v]?.isExternalBom || (listOfBOM[v]?.isExternalBom && !_check_p('DOWNLOAD_BOM').status)))  && (
                                        listOfBOM[v].totalCount < 201 ?
                                            (listOfBOM[v].isDownloadLoad ?
                                                <AxiosIndicatorRunTimeLoader bomLoaderClass={true} /> :
                                                <div className={"text-nowrap  d-flex align-items-center"}
                                                    onClick={() => {
                                                        store.dispatch(SET_DOWNLOAD_LOADER({ bomId: listOfBOM[v].bomId, isLoad: true, projectId: project_id }));
                                                        System.popup('DownloadBomPopup', {
                                                            single_bom: listOfBOM[v],
                                                            manageLoad: true,
                                                            projectId: project_id
                                                        });
                                                    }}
                                                ><i className="fa fa-download font-16 me-1" /><a> Download</a></div>
                                            ) :
                                            <Tooltip
                                                position={'bottom center'}
                                                opener={() => (
                                                    <div className="text-nowrap">
                                                        <i className="fa fa-download font-16 me-1" />
                                                        <a className='disabled-link' style={{ cursor: 'default' }}> Download</a>
                                                    </div>
                                                )}
                                                content={() => (
                                                    <div>
                                                        Download is limited to BOMs with 200 items or less. 
                                                        You can still email this BOM using the Email button.
                                                    </div>
                                                )}
                                            />
                                    )}
                                    </td>
                                    <td>
                                        <div className="text-nowrap d-flex align-items-center">
                                            <i className="fa fa-trash-o me-1 font-16 font-bold" />
                                            <a
                                                data-toggle="modal"
                                                href={void (0)}
                                                onClick={() => {
                                                    store.dispatch(system_notification({
                                                        name: 'BomDeletePopup',
                                                        data: {
                                                            single_bom: listOfBOM[v]
                                                        },
                                                    }));
                                                }}> Delete </a>
                                        </div>
                                    </td>
                                </Drag>
                            ))}
                        </table>
                    </div>
                </li>
            </ul>
        </>
    );
}

export default BomListUl;